import navigation from "@/lang/tr/navigation";
import generics from "@/lang/tr/generics";
import questions from "@/lang/tr/questions";
import a11y from "@/lang/tr/a11y";
import velt from "@/lang/tr/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
